module.exports = __webpack_public_path__ + "static/media/angelhack.aa58520f.jpg";